/**
 * Heurystyczna detekcja podpisu cyfrowego w pliku XML.
 *
 * Sprawdza obecność elementu <Signature> w przestrzeni nazw XML Digital Signature
 * (https://www.w3.org/TR/xmldsig-core/). Dotyczy zarówno XAdES (e-SF KSeF/eSprF),
 * jak i podpisów Profilem Zaufanym (PZ).
 *
 * UWAGA: To sprawdzenie jest heurystyczne (tekstowe) i służy TYLKO do decyzji
 * czy pokazać modal po stronie frontu. Pełna kryptograficzna weryfikacja odbywa
 * się po stronie backendu.
 *
 * @param {File} file - plik XML do sprawdzenia
 * @returns {Promise<boolean>} true jeśli plik posiada znacznik podpisu cyfrowego
 */
export const hasXmlDigitalSignature = async (file) => {
    try {
        const text = await file.text();
        // XML Digital Signature Namespace W3C — obecne w podpisach XAdES, CAdES, PZ
        return (
            text.includes('<Signature ') ||
            text.includes('<Signature>') ||
            text.includes('<ds:Signature ') ||
            text.includes('<ds:Signature>') ||
            text.includes('<xades:Signature ') ||
            text.includes('xmldsig#')
        );
    } catch (e) {
        console.warn('xmlSignatureCheck: błąd odczytu pliku', e);
        // W razie błędu odczytu — traktuj jako podpisany (bezpieczna wartość domyślna)
        return true;
    }
};
